import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel"]

  connect() {
    const params = new URLSearchParams(window.location.search)
    const tab = params.get("settings_tab")
    if (tab) {
      const target = this.tabTargets.find(t => t.dataset.tab === tab)
      if (target) this.switch({ currentTarget: target })
    }
  }

  switch(event) {
    event.preventDefault()
    const name = event.currentTarget.dataset.tab
    if (!name) return

    this.tabTargets.forEach(t => {
      t.classList.remove("border-black", "text-black")
      t.classList.add("border-transparent", "text-[#959494]", "hover:text-black", "hover:border-black/30")
    })
    event.currentTarget.classList.remove("border-transparent", "text-[#959494]", "hover:text-black", "hover:border-black/30")
    event.currentTarget.classList.add("border-black", "text-black")

    this.panelTargets.forEach(p => p.classList.add("hidden"))
    const panel = this.panelTargets.find(p => p.dataset.tab === name)
    if (panel) panel.classList.remove("hidden")
  }
}
